import React from 'react';

export const CustomerPageHeading = ({ title, description, icon: Icon, testId }) => <header className="customer-page-heading print:hidden">
  {Icon && <span className="customer-eyebrow"><Icon size={15} />MALDHOWR</span>}
  <h1 data-testid={testId}>{title}</h1>
  {description && <p data-testid={`${testId}-description`}>{description}</p>}
</header>;